module.exports = __webpack_public_path__ + "static/img/questionASel.2a5440ac.png";